document.addEventListener('DOMContentLoaded', () => {
    runTabs();
})

function runTabs() {
    const tabs = document.querySelectorAll('.eggo-product-tabs');
    if (tabs.length === 0) return;
    tabs.forEach(tab => {
        const tabButtons = tab.querySelectorAll('.eggo-product-tabs__buttons a.with-products');
        const tabProducts = tab.querySelectorAll('.eggo-product-tabs__products');
        if (tabButtons.length === 0 || tabProducts.length === 0) return;

        tabButtons.forEach(tabButton => {
            tabButton.addEventListener('click', (e) => {
                e.preventDefault();
                tabButtons.forEach(button => button.classList.remove('visible'));
                tabProducts.forEach(products => products.classList.remove('visible'));
                tabButton.classList.add('visible');
                const index = tabButton.dataset.index;
                const tabSelectedProducts = tab.querySelector('.eggo-product-tabs__products[data-index="' + index + '"]');
                console.log(tabSelectedProducts);
                if (!tabSelectedProducts) return;
                tabSelectedProducts.classList.add('visible');
            })
        })
    })
}